/**
 * DEV-ONLY preview mode. With the Vite dev server and `?preview=1` in the URL the
 * portal skips Supabase auth and serves fixture data (src/dev/fixtures.ts) through
 * the same data-access layer, so screens can be reviewed without a real login.
 * `?preview=login` shows the sign-in screen with a simulated magic link send, and
 * `?preview=empty`, `?preview=error` or `?preview=loading` exercise those screen states.
 *
 * `import.meta.env.DEV` is replaced with the literal `false` in production builds,
 * so every `if (PREVIEW)` branch, and the fixtures module it imports, is removed.
 */
const param = import.meta.env.DEV && typeof window !== "undefined" ? new URLSearchParams(window.location.search).get("preview") : null;

export const PREVIEW: boolean = import.meta.env.DEV && (param === "1" || param === "login" || param === "empty" || param === "error" || param === "loading");
export const PREVIEW_SIGNED_OUT: boolean = import.meta.env.DEV && param === "login";
